import { Link } from 'react-router';
import './mentions-legales.scss';
import arrowWhiteLeft from './images/arrow-white-left.svg';

export default function MentionsLegales() {
    return (
        <>
            <div className="mentionsLegales">
                <Link to="/"><img src={arrowWhiteLeft} /></Link>
                <h1>Mentions Légales</h1>
                <h2>1. Éditeur du site</h2>
                <p>
                    Le présent site est édité par :<br/>
                    <b>Nom / Raison sociale</b> : ELIANA CONSULTING<br/>
                    <b>Statut juridique</b> : SAS<br/>
                    <b>Adresse</b> : 220 AVENUE DE LA LIBERATION CHARLES DE GAULLE 33110 LE BOUSCAT<br/>
                    <b>Numéro SIRET</b> : 98781516400015<br/>
                    <b>Numéro TVA intracommunautaire</b> : FR56987815164<br/>
                    <b>Email</b> : <a href="mailto:contact@eliana-consulting.com">contact@eliana-consulting.com</a><br/>
                </p>
                <h2>2. Directeur de la publication</h2>
                <p>
                    Le directeur de la publication est :<br/>
                    <b>Nom et prénom</b> : Batalha Gaspar Amar
                </p>
                <h2>3. Hébergement du site</h2>
                <p>
                    Le site est hébergé par :<br/>
                    <b>Nom de l’hébergeur</b> : OVH<br/>
                    <b>Adresse</b> : 2 rue Kellermann - 59100 Roubaix - France<br/>
                    <b>Téléphone</b> : <a href="tel:+33 09 72 10 10 07">+33 09 72 10 10 07</a><br/>
                    <b>Site web</b> : <a href="https://www.ovhcloud.com/">https://www.ovhcloud.com/</a><br/>
                </p>
                <h2>4. Propriété intellectuelle</h2>
                <p>
                    L’ensemble des contenus présents sur ce site (textes, images, logos, etc.) est protégé par le droit de la propriété intellectuelle.<br/>
                    Toute reproduction, distribution ou utilisation sans autorisation préalable est interdite.
                </p>
                <h2>5. Données personnelles</h2>
                <p>
                    Les informations collectées via le site sont destinées uniquement à finalité de contact.
                </p>
                <p>
                    Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
                </p>
                <ul>
                    <li>Droit d’accès</li>
                    <li>Droit de rectification</li>
                    <li>Droit de suppression</li>
                    <li>Droit d’opposition</li>
                </ul>
                <p>
                    Pour exercer ces droits, vous pouvez contacter : <a href="mailto:contact@eliana-consulting.com">contact@eliana-consulting.com</a>
                </p>
                <h2>6. Cookies</h2>
                <p>
                    Le site peut utiliser des cookies afin d’améliorer l’expérience utilisateur.<br/>
                    Vous pouvez configurer votre navigateur pour refuser les cookies.
                </p>
                <h2>7. Responsabilité</h2>
                <p>
                    L’éditeur du site ne saurait être tenu responsable des erreurs ou omissions dans les informations diffusées, ni de l’utilisation qui pourrait en être faite.
                </p>
            </div>
        </>
    );
}